import { Chip, FormControl, InputLabel } from '@material-ui/core';
import { format } from 'date-fns';
import React from 'react';
import { Link } from 'react-router-dom';
import { legacyParse, convertTokens } from '@date-fns/upgrade/v2';

import { primaryBlue, red } from 'utils/color-styles';
import { currencyFormat } from 'utils/currencyFormat';

const BudgetAllocationCompact = ({
  budgetAllocation,
  budgetInactive,
  primaryLabel,
  urlPath,
  donationsCount,
  extraMatchingGrantsFields,
}) => {
  const now = new Date();
  const limitTotal = budgetAllocation.get('limitTotal');
  const totalIssued = budgetAllocation.get('totalIssued');
  const endingAt = budgetAllocation.get('endingAt');
  const startingAt = budgetAllocation.get('startingAt');
  const currencyCode = budgetAllocation.get('currencyCode');
  const limitPerUser = budgetAllocation.get('limitPerUser');
  const rewardAmount = budgetAllocation.get('rewardAmount');

  const balance = limitTotal ? limitTotal - totalIssued : undefined;

  const inactive =
    budgetInactive || (endingAt && endingAt < now) || (startingAt && startingAt > now);
  const balanceLow = limitTotal && !inactive && balance / limitTotal < 0.15;

  const opacity = inactive ? '0.5' : '1';

  return (
    <div
      style={{
        border: `1px solid rgba(0, 0, 0, ${inactive ? '0.1' : '0.2'})`,
        padding: '10px 30px 15px 30px',
        marginBottom: 30,
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: 0,
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            opacity,
          }}
        >
          <h3>{budgetAllocation.get('title')}</h3>
          <Chip color="primary" label={primaryLabel} style={{ marginLeft: 20 }} />
          <Chip label={currencyCode} style={{ marginLeft: 20 }} />
        </div>
        {/* We do not support editing or deleting of volunteer grants for now */}
        {!extraMatchingGrantsFields && (
          <Link
            to={`/donations/${urlPath}/${budgetAllocation.get('id')}`}
            style={{
              color: primaryBlue,
              textDecoration: 'underline',
              opacity: budgetInactive ? '0.5' : 1,
            }}
          >
            Edit
          </Link>
        )}
      </div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: 15,
          opacity,
        }}
      >
        <div style={{ width: '15%' }}>
          <FormControl style={{ width: '100%', height: 17 }}>
            <InputLabel shrink>Used</InputLabel>
          </FormControl>
          <div>{currencyFormat(totalIssued, currencyCode)}</div>
        </div>
        <div style={{ width: '15%', color: balanceLow ? red : undefined }}>
          <FormControl style={{ width: '100%', height: 17 }}>
            <InputLabel shrink>Balance</InputLabel>
          </FormControl>
          <div>{limitTotal ? currencyFormat(limitTotal - totalIssued, currencyCode) : '-'}</div>
        </div>
        <div style={{ width: '15%' }}>
          <FormControl style={{ width: '100%', height: 17 }}>
            <InputLabel shrink>Allocated</InputLabel>
          </FormControl>
          <div>{limitTotal ? currencyFormat(limitTotal, currencyCode) : '-'}</div>
        </div>
        {extraMatchingGrantsFields && (
          <>
            <div style={{ width: '15%' }}>
              <FormControl style={{ width: '100%', height: 17 }}>
                <InputLabel shrink>Limit Per User</InputLabel>
              </FormControl>
              <div>{limitPerUser ? currencyFormat(limitPerUser, currencyCode) : '-'}</div>
            </div>
            <div style={{ width: '15%' }}>
              <FormControl style={{ width: '100%', height: 17 }}>
                <InputLabel shrink>Reward Amount</InputLabel>
              </FormControl>
              <div>{rewardAmount ? currencyFormat(rewardAmount, currencyCode) : '-'}</div>
            </div>
          </>
        )}
        <div style={{ width: '15%' }}>
          <FormControl style={{ width: '100%', height: 17 }}>
            <InputLabel shrink>Donation Count</InputLabel>
          </FormControl>
          <div>{donationsCount || 0}</div>
        </div>
        <div style={{ width: '20%' }}>
          <FormControl style={{ width: '100%', height: 17 }}>
            <InputLabel shrink>Start &amp; End Date</InputLabel>
          </FormControl>
          <div>
            {startingAt || endingAt ? (
              <>
                {startingAt ? format(legacyParse(startingAt), convertTokens('YYYY-MM-DD')) : 'N/A'}
                {' – '}
                {endingAt ? format(legacyParse(endingAt), convertTokens('YYYY-MM-DD')) : 'N/A'}
              </>
            ) : (
              'Not constrained'
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BudgetAllocationCompact;
